/** Wrap story block with `className="group"` and merge this into `ArtistStoryRichText` `className`. */
export const WEBSITE_STORY_HOVER_TEXT =
  'transition-colors duration-200 [&_*]:transition-colors group-hover:text-[#F33363] group-hover:[&_*]:text-[#F33363] group-hover:[&_a]:text-[#F33363]';
